import { useState } from "react";
import ButtonIcon from "../common/buttonIcon";

const InputSearch = (props: any) => {

  let placeholder = props.placeholder ?? '';

  const UpdadeValue = (valueInput: any) => {
    setSearch(valueInput);
    props.handleClick(search)
  }

  const ClickButton = () => {
    props.handleClick(search)
  }

  const [search, setSearch] = useState("");
  return (
    <div className="InputSearch">
      <input value={search} placeholder={placeholder} onKeyUp={(e) => { const target = e.target as HTMLButtonElement; if (target) UpdadeValue(target.value); }} onChange={(e) => UpdadeValue(e.target.value)} className="form-control Input" />
      <ButtonIcon handleClick={ClickButton} icon="search" />
    </div>
  )
}

export default InputSearch;
